module.exports = __webpack_public_path__ + "img/40_38_035_490.21c9ee08.jpg";